import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto7() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.1 41.89" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path
						class="cls-1"
						d="M6.53,24.78a.64.64,0,0,1-.45-.19L3.26,21.78c-5-5-2.88-11.86,1.44-16.48A18.59,18.59,0,0,1,9.14,1.74C11.51.43,18-1,22.18,3.05l8.45,8.45a1.89,1.89,0,0,1,.31,2.66c-.07.07-.13.15-.2.21-1.4,1.41-5.11,1.87-7.39-.37l-2.12-2.1c-1.09-1-2.32-.69-4.21-.12-2.15.65-4.83,1.46-7.77-.86A.63.63,0,0,1,9.14,10h0A.64.64,0,0,1,10,9.92c2.42,1.91,4.55,1.27,6.62.64C18.5,10,20.4,9.44,22.1,11l2.14,2.12a4.46,4.46,0,0,0,5.6.38c.25-.25.41-.55-.1-1.07L21.29,4C17.58.37,11.82,1.69,9.77,2.84A17.27,17.27,0,0,0,5.63,6.17C2,10-.52,16.21,4.16,20.89L7,23.7a.62.62,0,0,1,0,.87v0A.64.64,0,0,1,6.53,24.78Z"
					/>
					<path
						class="cls-1"
						d="M39.42,23.45a.7.7,0,0,1-.45-.19.65.65,0,0,1,0-.9l2.81-2.77c4.45-4.45,2.62-10.4-1-14S31-.23,26.31,4.3l-1.9,1.88a.63.63,0,0,1-.89-.11.65.65,0,0,1,0-.79l1.9-1.87c5-4.93,12-3.11,16.29,1.23,4,4.05,6.07,10.76,1,15.82l-2.89,2.8A.63.63,0,0,1,39.42,23.45Z"
					/>
					<path
						class="cls-1"
						d="M8.22,30.29a3,3,0,0,1-2.12-.9,3.54,3.54,0,0,1-.27-5L16.72,13a.62.62,0,0,1,.89.07.63.63,0,0,1,0,.8L6.75,25.3A2.28,2.28,0,0,0,7,28.48a1.82,1.82,0,0,0,2.57,0,2.75,2.75,0,0,0,.22-.26L14.83,23a.63.63,0,0,1,.9,0,.65.65,0,0,1,0,.9l-5.06,5.26A3.45,3.45,0,0,1,8.22,30.29Z"
					/>
					<path
						class="cls-1"
						d="M12.37,34.13A3.88,3.88,0,0,1,9.72,33a3.21,3.21,0,0,1-.24-4.54,2.72,2.72,0,0,1,.24-.24l5.52-5.61a.63.63,0,0,1,.9,0,.62.62,0,0,1,0,.87l0,0-5.47,5.66a2,2,0,0,0-.31,2.74,1.31,1.31,0,0,0,.23.24,2.2,2.2,0,0,0,3.1.18l5.61-5.76a.64.64,0,0,1,.91.89h0l-5.61,5.77A3.06,3.06,0,0,1,12.37,34.13Z"
					/>
					<path
						class="cls-1"
						d="M16.85,37.57a3.8,3.8,0,0,1-2.57-1.07,3.18,3.18,0,0,1-.19-4.5,3.57,3.57,0,0,1,.28-.27.65.65,0,0,1,.9,0,.63.63,0,0,1,0,.9,1.93,1.93,0,0,0-.34,2.71,1.51,1.51,0,0,0,.21.23,2.17,2.17,0,0,0,3,.12L21,32.86a.65.65,0,0,1,.9,0,.64.64,0,0,1,0,.89h0l-2.81,2.82A3.13,3.13,0,0,1,16.85,37.57Z"
					/>
					<path
						class="cls-1"
						d="M25.12,41.51h0a3.16,3.16,0,0,1-2.28-.94L20.24,38a3.21,3.21,0,0,1,0-4.56h0l.3-.3a3.15,3.15,0,0,1,2.09-1,3.25,3.25,0,0,1,.29-4.26l.3-.3a3.2,3.2,0,0,1,2.21-.92,3.11,3.11,0,0,1-.89-2.22,3.2,3.2,0,0,1,.94-2.3l.3-.29a3.17,3.17,0,0,1,2.29-.95h0a3.19,3.19,0,0,1,2.29.95l.7.7A3.2,3.2,0,0,1,32,20.38l.3-.3a3.18,3.18,0,0,1,2.29-.94h0a3.18,3.18,0,0,1,2.29.94L40.75,24a3.24,3.24,0,0,1,0,4.58h0l-.29.31a3.29,3.29,0,0,1-2.3.94h0a3.82,3.82,0,0,1-.75-.08,3.15,3.15,0,0,1,.06.61,3.2,3.2,0,0,1-.94,2.3l-.3.29a3.26,3.26,0,0,1-3.25.81,3.22,3.22,0,0,1-.91,2.72l-.3.31a3.27,3.27,0,0,1-3.14.83,3.75,3.75,0,0,1-.94,2.71l-.29.29A3.26,3.26,0,0,1,25.12,41.51ZM21.43,34l-.29.29a2,2,0,0,0,0,2.77h0l2.6,2.6a1.93,1.93,0,0,0,1.38.58h0a2,2,0,0,0,1.4-.58l.29-.29a2,2,0,0,0,.58-1.4,2,2,0,0,0-.58-1.39L24.21,34a2,2,0,0,0-2.77,0Zm4.12-6.07a2,2,0,0,0-1.4.57l-.29.3a2,2,0,0,0,0,2.78l4.23,4.2a2,2,0,0,0,2.77,0h0l.3-.31a2,2,0,0,0,0-2.77h0l-4.24-4.2a1.88,1.88,0,0,0-1.38-.57Zm2.52-5.77a2,2,0,0,0-1.39.57h0l-.3.3a2,2,0,0,0-.57,1.4,1.94,1.94,0,0,0,.57,1.38L32.55,32a2,2,0,0,0,2.79,0l.29-.29a2,2,0,0,0,.58-1.4,1.93,1.93,0,0,0-.58-1.38l-6.17-6.18A2,2,0,0,0,28.07,22.16Zm6.52-1.78a2,2,0,0,0-1.4.58h0l-.29.3a2,2,0,0,0-.58,1.37A2,2,0,0,0,32.9,24l3.89,3.89a2,2,0,0,0,1.39.56h0a2,2,0,0,0,1.4-.56l.3-.31a2,2,0,0,0,0-2.78L36,21a1.92,1.92,0,0,0-1.41-.58Z"
					/>
				</g>
			</g>
		</svg>
	);
}
